/** @internal P-1D-R1 — narrow refresh outcome codes (no token values). */
export const REFRESH_OUTCOME = {
  SUPERSEDED_SESSION_CLEAR: 'REFRESH_SUPERSEDED_BY_SESSION_CLEAR',
  SUPERSEDED_ACCOUNT_SWITCH: 'REFRESH_SUPERSEDED_BY_NEW_SESSION',
  SUPERSEDED_TERMINATED: 'COORDINATOR_TERMINATED',
};

/**
 * Stale refresh context abandoned — not current-session invalidation.
 * Must not trigger terminal logout, persistence clear, Redux mutation, or navigation.
 */
export class RefreshSupersededError extends Error {
  constructor(outcome, message) {
    super(message);
    this.name = 'RefreshSupersededError';
    this.outcome = outcome;
    this.sessionChanged = true;
  }
}

export function isRefreshSupersededError(err) {
  return err instanceof RefreshSupersededError || err?.name === 'RefreshSupersededError';
}
